import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'
import global from '../../utils/global'
const vue = new Vue()
function changeSelect (data) {
  if (data.obj.length === 0) return false
  if (!data.obj[0].value || !data.obj[0].id) {
    data.obj.forEach(item => {
      item.value = item.code
    })
  }
}
const state = {
  /*
  * 商品管理
  * */
  goodsManageList: {},
  otherCost: {},
  goodsManageMark: 0,
  goodsManageInfo: {}, // 编辑详情
  goodsManageSelect: [], // 下拉框 - 商品属性
  goodsWeightTypeSelect: [], // 下拉框 - 商品类型
  classification: [],
  attributes: [],
  goodsManageygccode: [], // 下拉框 - 分类
  supplierSelect: [], // 下拉框 - 供应商（共用）
  piont: [], // 配送仓点
  xlsUrl: null, // xls下载地址
  costMask: 0,
  isAcc: 1, // 是否累加
  /**
   * 未审商品
   */
  notVerifyList: {
    total: 0
  },
  notVerifyLists: {
    total: 0
  },
  notVerifyListd: {
    total: 0
  },
  notVerifyMark: 0,
  companyList: []
}

const actions = {
  /*
  * 商品管理
  * */
  // 获取列表
  [types.GOODSGETPAGE] (context, params) {
    http.fetch('/api/goods/getPage', params).then(data => {
      context.commit(types.GOODSGETPAGE, data)
    })
  },
  // 下拉框 - 商品属性 / 货位类型  / 任务类型(共用)
  // [types.DICTGETCHILDS] (context, params) {
  //   http.fetch('/api/dict/getChild', params).then(data => {
  //     context.commit(types.DICTGETCHILDS, data)
  //   })
  // },
  [types.DICTGETCHILDS] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/dict/getChild', params).then(data => {
        resolve(data.obj)
      })
    })
  },
  // 下拉分类
  [types.YGCCODE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/dict/getChild', params).then(data => {
        resolve(data.obj)
      })
    })
  },
  // 下拉框 - 商品类型
  [types.DICTGETCHILDS2] (context, params) {
    http.fetch('/api/dict/getChild', params).then(data => {
      context.commit(types.DICTGETCHILDS2, data)
    })
  },
  [types.CLASSIFICATION] (context, params) {
    http.fetch('/api/dict/getChild', params).then(data => {
      context.commit(types.CLASSIFICATION, data)
    })
  },
  [types.ATTRIBUTES] (context, params) {
    http.fetch('/api/dict/getChild', params).then(data => {
      context.commit(types.ATTRIBUTES, data)
    })
  },
  // 下拉框 - 供应商（共用）
  [types.SUPPLIERGETLISTS] (context, params) {
    http.fetch('/api/supplier/getAllSupplier', params).then(data => {
      context.commit(types.SUPPLIERGETLISTS, data)
    })
  },
  // 新增、编辑时查询是否为"累加"，是则不显示费用配置
  [types.GETISACC] (context, params) {
    http.fetch('/api/goods/getIsAcc', params).then(data => {
      context.commit(types.GETISACC, data)
    })
  },
  // 新增
  [types.GOODSADD] (context, params) {
    http.fetch('/api/goods/add', params).then(data => {
      context.commit(types.GOODSADD, data)
    })
  },
  // 编辑
  [types.GOODSUPDATE] (context, params) {
    http.fetch('/api/goods/update', params).then(data => {
      context.commit(types.GOODSUPDATE, data)
    })
  },
  // 编辑回显
  [types.GOODSGETGOODS] (context, params) {
    http.fetch('/api/goods/getGoods', params).then(data => {
      context.commit(types.GOODSGETGOODS, data)
    })
  },
  // 删除
  [types.GOODSDELETE] (context, params) {
    http.fetch('/api/goods/delete', params).then(data => {
      if (params.type) { data.type = true }
      context.commit(types.GOODSDELETE, data)
    })
  },
  // 导入
  [types.IMPORTGOODS] (context, params) {
    http.fetch('/api/goods/importGoods', params).then(data => {
      context.commit(types.IMPORTGOODS, data)
    })
  },
  /**
   * 获取未审商品列表
   */
  [types.GETNOTPASSGOOD] (context, params) {
    http.fetch('/api/goods/getNotPassGood', params).then(data => {
      context.commit(types.GETNOTPASSGOOD, data)
    })
  },
  /**
   * 首页获取未审商品
   */
  [types.GETNOTPASSGOODS] (context, params) {
    http.fetch('/api/goods/getNotPassGood', params).then(data => {
      context.commit(types.GETNOTPASSGOODS, data)
    })
  },
  /**
   * 获取未审商品页面数据
   */
  [types.GETNOTPASSGOODD] (context, params) {
    http.fetch('/api/goods/getNotPassGood', params).then(data => {
      context.commit(types.GETNOTPASSGOODD, data)
    })
  },
  // 审核商品
  [types.GOODSPASSGOOD] (context, params) {
    http.fetch('/api/goods/passGood', params).then(data => {
      context.commit(types.GOODSPASSGOOD, data)
    })
  },
  // 开启日期管理
  [types.OPENDATEMANAGE] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/goods/goodsOpenStart', params).then(data => {
        context.commit(types.OPENDATEMANAGE, data)
        resolve(data.obj)
      })
    })
  },
  // 获取单位
  [types.GETCOMPANY] (context, params) {
    http.fetch('/api/dict/getChild', params).then(data => {
      context.commit(types.GETCOMPANY, data)
    })
  }
}

const mutations = {
  /*
  * 商品管理
  * */
  // 获取列表
  [types.GOODSGETPAGE] (state, data) {
    state.goodsManageList = data
  },
  // 下拉框 - 商品属性 / 货位类型 (共用)
  [types.DICTGETCHILDS] (state, data) {
    changeSelect(data)
    state.goodsManageSelect = data.obj
  },
  [types.YGCCODE] (state, data) {
    changeSelect(data)

    state.goodsManageygccode = data.obj
  },
  // 下拉框 - 商品属性 / 货位类型 (共用)
  [types.DICTGETCHILDS2] (state, data) {
    changeSelect(data)
    state.goodsWeightTypeSelect = data.obj
  },
  [types.CLASSIFICATION] (state, data) {
    changeSelect(data)
    state.classification = data.obj
  },
  [types.ATTRIBUTES] (state, data) {
    changeSelect(data)
    state.attributes = data.obj
  },
  // 下拉框 - 供应商（共用）
  [types.SUPPLIERGETLISTS] (state, data) {
    data.obj.forEach(item => {
      item.name = item.supplierName
      item.id = item.supplierCode
    })
    state.supplierSelect = data.obj
  },
  // 新增、编辑时查询是否为"累加"，是则不显示费用配置
  [types.GETISACC] (state, data) {
    state.isAcc = data.obj.isAcc
  },
  // 新增
  [types.GOODSADD] (state, data) {
    console.log(data, 'GOODSADD')
    if (data.success) {
      state.costMask = 1
      state.goodsManageMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
    }
  },
  // 编辑
  [types.GOODSUPDATE] (state, data) {
    if (data.code !== 200) return
    state.costMask = 1
    state.goodsManageMark = 1
    vue.$message({
      showClose: true,
      message: '编辑成功',
      type: 'success'
    })
  },
  // 编辑回显
  [types.GOODSGETGOODS] (state, data) {
    data = data.obj
    // 图片回显
    if (data.url) {
      let imgList = data.url.split(',')
      data.url = imgList.map(item => {
        return {
          url: `${global.httpBaseURL}/image/${item}`,
          submitUrl: item
        }
      })
    } else {
      data.url = []
    }
    // 不足一箱、计算规则回显
    if (data.smallestRule) {
      data.smallestRule = JSON.parse(data.smallestRule)
    } else {
      data.smallestRule = {
        a: '',
        b: '',
        c: ''
      }
    }
    // 外箱长、宽、高、毛重
    let dimensionsList = ['boxLong', 'boxHigh', 'boxWide', 'weight']
    dimensionsList.forEach(item => {
      if (data[item] === 0) {
        data[item] = '0.00'
      }
    })

    state.goodsManageInfo = data
  },
  // 删除
  [types.GOODSDELETE] (state, data) {
    if (data.code !== 200) return
    if (data.type) {
      state.notVerifyMark = 1
    } else {
      state.goodsManageMark = 1
      state.costMask = 1
    }
    vue.$message({
      showClose: true,
      message: '删除成功',
      type: 'success'
    })
  },
  // 导入
  [types.IMPORTGOODS] (state, data) {
    if (data.code !== 200) {
      state.goodsManageMark = -1
      state.xlsUrl = {
        url: '',
        message: data.message
      }
      return false
    }
    if (data.obj) {
      state.xlsUrl = {
        url: data.obj,
        message: '导入失败'
      }
      state.goodsManageMark = 2
    } else {
      state.xlsUrl = {
        url: '',
        message: '商品信息导入成功'
      }
      state.goodsManageMark = 3
    }
  },
  /**
   * 获取未审商品列表
   */
  [types.GETNOTPASSGOOD] (state, data) {
    data = data.obj
    if (data.records) {
      data.rows = data.records
    }
    state.notVerifyList = data
  },
  [types.GETNOTPASSGOODS] (state, data) {
    data = data.obj
    if (data.records) {
      data.rows = data.records
    }
    state.notVerifyLists = data
  },
  [types.GETNOTPASSGOODD] (state, data) {
    data = data.obj
    if (data.records) {
      data.rows = data.records
    }
    state.notVerifyListd = data
  },
  // 审核商品
  [types.GOODSPASSGOOD] (state, data) {
    if (data.code === 200) {
      state.notVerifyMark = 1
      vue.$message({
        showClose: true,
        message: '审核成功',
        type: 'success'
      })
    }
  },
  // 开启日期管理
  [types.OPENDATEMANAGE] (state, data) {
    if (data.code === 200) {
      state.goodsManageMark = 4
      if (data.obj.msg) return false
      vue.$message({
        showClose: true,
        message: '操作成功',
        type: 'success'
      })
    }
  },
  // 获取单位
  [types.GETCOMPANY] (state, data) {
    changeSelect(data)
    state.companyList = data.obj
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/goodsManage/index.js